import uniq from 'lodash/uniq';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DomainFlattened, Juridiction, Ville } from '../../entity/entity.types';
import { LawFirmInfos } from '../lawFirm.types';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { withUser } from '../../user/UserContext';
import { fetchLawFirmDecisions } from '../lawFirm.api';
import { flattenDomains } from '../../entity/expertises/entityExpertises.utils';
import { MultipleLawFirmMain } from './firm/MultipleLawFirmMain';
import { UniqueLawFirmMain } from './unique/UniqueLawFirmMain';
import { OfficeMain } from './office/OfficeMain';
import { UserContextType } from '../../user/user.types';
import { getPageName } from '../../utils/pageName';

type Props = {
  lawFirmInfos: LawFirmInfos;
} & UserContextType;

type State = {
  experience: {
    domains: Array<DomainFlattened>;
    juridictions: Array<Juridiction>;
    villes: Array<Ville>;
    decisionCount: number;
  };
  loaded: boolean;
};

export class RawLawFirmMain extends React.Component<Props, State> {
  state: State = {
    experience: { domains: [], juridictions: [], villes: [], decisionCount: 0 },
    loaded: false,
  };

  async componentDidMount() {
    const { domains, juridictions, villes, decisionCount } = (
      await fetchLawFirmDecisions(
        uniq(this.props.lawFirmInfos.offices.map(office => office.lawOfficeId)),
      )
    ).data;
    this.setState({
      experience: {
        domains: flattenDomains(domains),
        juridictions,
        villes,
        decisionCount,
      },
      loaded: true,
    });
  }

  render() {
    const {
      lawFirmInfos: { name, lawOfficeIdGroup, offices },
      lawFirmInfos,
      accessPremium,
      loggedIn,
    } = this.props;
    const { experience, loaded } = this.state;
    const allDecisionsLink = buildUrlWithParameters('/search', {
      q: encodeURIComponent(name),
      chrono: true,
      oid: lawOfficeIdGroup,
      sourcePage: getPageName(),
    });
    return (
      <Switch>
        <Route
          exact
          path="/p/cabinet/:name/:id"
          render={() => {
            if (offices.length > 1) {
              return (
                <MultipleLawFirmMain
                  lawFirmInfos={lawFirmInfos}
                  loggedIn={loggedIn}
                  experience={experience}
                  loaded={loaded}
                  allDecisionsLink={allDecisionsLink}
                />
              );
            }
            return (
              <UniqueLawFirmMain
                lawFirmInfos={lawFirmInfos}
                accessPremium={accessPremium}
                loggedIn={loggedIn}
                experience={experience}
                loaded={loaded}
                allDecisionsLink={allDecisionsLink}
              />
            );
          }}
        />
        <Route
          exact
          path="/p/cabinet/:name/:id/:ville/:nic"
          render={() => (
            <OfficeMain
              lawFirmInfos={lawFirmInfos}
              accessPremium={accessPremium}
            />
          )}
        />
      </Switch>
    );
  }
}

export const LawFirmMain = withUser(RawLawFirmMain);
